import { Modal } from '@salecycle/ui-component-library';
import { useCallback } from 'react';
import styled from 'styled-components';
import { useCampaignEditorContext } from '../../contexts/CampaignEditorContext';
import { useTranslation } from 'react-i18next';
import { useMoveToStatus } from '../../hooks/useMoveToStatus';
import { OnsiteCampaignStatus } from 'sections/onsite-campaigns/types';

const ModalContainer = styled.div`
  display: block;
`;

export interface ConfirmTestModeModalProps {
  open: boolean;
  onClose: () => void;
}

export const ConfirmTestModeModal = ({ open, onClose }: ConfirmTestModeModalProps) => {
  const { t } = useTranslation('campaigns');
  const { dispatch } = useCampaignEditorContext();
  const moveToStatus = useMoveToStatus();

  const onRevertToDraft = useCallback(() => {
    dispatch({ type: 'SET_CAMPAIGN_STATUS', payload: { status: 'Draft' } });
    moveToStatus(OnsiteCampaignStatus.DRAFT);
    onClose();
  }, [dispatch, moveToStatus, onClose]);

  return (
    <Modal
      minWidth={570}
      heading={t('onsite.editor.workflow.confirmTestModeModal.heading')}
      isOpen={open}
      variation="clean"
      onCloseButtonClicked={onClose}
      // We need to swap the confirm/cancel as we want the primary button to be on the left hand side
      // of the modal
      onCancelButtonClicked={onClose}
      cancelButtonLabel={t('onsite.editor.workflow.confirmTestModeModal.closeButton')}
      cancelButtonAriaLabel={t('onsite.editor.workflow.confirmTestModeModal.closeButton')}
      cancelButtonType={'primary'}
      onOkButtonClicked={onRevertToDraft}
      okButtonLabel={t('onsite.editor.workflow.confirmTestModeModal.confirmButton')}
      okButtonAriaLabel={t('onsite.editor.workflow.confirmTestModeModal.confirmButton')}
      okButtonType={'secondary'}
    >
      <ModalContainer>
        <div>{t('onsite.editor.workflow.confirmTestModeModal.body')}</div>
      </ModalContainer>
    </Modal>
  );
};
